import {Button, Text} from "bounce-ui/backoffice";
import {IPlanMatrix} from "../../../../../../../../declerations/server/payment_plan_models";
import {prettifyCurrencyRounded} from "@bounce/shared/helpers";
import {getRankStyles} from "../utils";

interface IPlanButton {
  plan: IPlanMatrix;
  setSelectedPlan: (selectedPlan: IPlanMatrix) => void;
  isSelected: boolean;
}

export const PlanButton = ({plan, setSelectedPlan, isSelected}: IPlanButton) => {
  const {color, backgroundColor, divider} = getRankStyles(plan.color, isSelected);
  return (
    <Button
      variant="outlined"
      onClick={() => {
        setSelectedPlan(plan);
      }}
      sx={{
        width: "80px",
        height: "34px",
        borderRadius: "4px",
        border: `1px solid ${divider}`,
        backgroundColor,
        padding: "0px",
        minWidth: "80px",
      }}
    >
      <Text variant={"inter600"} size={14} color={color}>
        {prettifyCurrencyRounded(plan.installment_size)}
      </Text>
    </Button>
  );
};
